define('home/templates/signUpAsideModule',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"aside__wrap -brand text-center\" data-role=\"login-prompt-module\">\n<h2 class=\"text-large text-bold\">"
    + alias2(helpers.gettext.call(alias1,"There's more to talk about...",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n<p>"
    + alias2(helpers.gettext.call(alias1,"Great discussions are happening here on %(disqus)s. You'll never be bored.",{"name":"gettext","hash":{"disqus":"Disqus"},"data":data}))
    + "</p>\n<p>\n<button class=\"button button-outline -border-light text-medium button-wide\" data-action=\"show-login-overlay\">\n"
    + alias2(helpers.gettext.call(alias1,"Join %(disqus)s",{"name":"gettext","hash":{"disqus":"Disqus"},"data":data}))
    + "\n</button>\n</p>\n</div>\n";
},"useData":true})

});
